import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatIconAnchor } from '@angular/material/button';
import { GtagEventDirective } from '../../../../core/gx-gtag/gtag-event.directive';
import { MatIcon } from '@angular/material/icon';
import { DiffCellLocalStoreService } from './diff-cell-local-store.service';
import { AgCellRendererComponent } from '../../../global/gx-ag-grid/ag-cell-renderer.component';
import { LetDirective } from '@ngrx/component';
import { PrependProtocolPipe } from '../../../../pipes/prepend-protocol.pipe';

@Component({
  selector: 'app-diff-cell',
  standalone: true,
  imports: [
    MatIconAnchor,
    GtagEventDirective,
    MatIcon,
    LetDirective,
    PrependProtocolPipe,
  ],
  templateUrl: './diff-cell.component.html',
  styleUrl: './diff-cell.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [DiffCellLocalStoreService]
})
export class DiffCellComponent extends AgCellRendererComponent {

  viewModel$ = this.localStore.viewModel$;

  constructor(protected localStore: DiffCellLocalStoreService) {
    super(localStore);
  }
}
